/**
 * Created by Bart Decorte
 * Date: 2019-07-17
 * Time: 11:31
 */
import LoadingStateImage from '../utils/LoadingStateImage';
import Column from './Column';

class LoadingStateColumn extends LoadingStateImage(Column) {
  constructor(params) {
    super(params);
  }
}

export default LoadingStateColumn;



// WEBPACK FOOTER //
// ./resources/assets/js/columns/LoadingStateColumn.js